// The file contents for the current environment will overwrite these during build.
// The build system defaults to the dev environment which uses `environment.ts`, but if you do
// `ng build --env=prod` then `environment.prod.ts` will be used instead.
// The list of which env maps to which file can be found in `.angular-cli.json`.

export const environment = {
  production: false,
  baseApiUrl: "https://legacydev-api.reveleer.com/corewebservice/api/",
  documentServiceApiUrl: "https://legacydev-api.reveleer.com/documentservice/api/",
  ssoRedirectUrl: "https://dev.reveleer.com/login/sso-redirect",
  auth0RedirectUrl: "https://dev.reveleer.com/login/select-user",
  idlePeriodInSec: 1740,
  idlePeriodInSecForEmployee: 540,
  timeoutPeriodInSec: 60,
  auth0Domain: "dev-reveleer.us.auth0.com",
  auth0ClientID: "IC13LjBCcsdrYMbbe60g8910bsp4GZvP",
  userPilotToken: "STG-NX-cefc6f56",
};

